import { useQuery } from "@apollo/client";
import { GET_OWNER_LISTINGS } from "@/graphql/queries/user";
import { useAuthState } from "@/contexts/auth/auth.provider";

export function useIsOwnerByQuery(listingId, skip) {
  const { token } = useAuthState();

  const { data, loading } = useQuery(GET_OWNER_LISTINGS, {
    variables: {
      listing_id: parseInt(listingId),
      limit: 1
    },
    context: { token },
    skip: skip || !listingId || !token,
  });

  const isOwner = !!data?.Listing?.getMyListings?.listings?.length;

  return {
    isOwner,
    loading,
    ownerListing: data?.Listing?.getMyListings?.listings?.[0]
  };
}
